import PDFViewer from "./browser/PdfView";
import DocView from "./browser/DocView";
import PbReaderPreview from "./pbreader/PbReaderPreview";
import { isPdf, getDocumentFileUrl } from "../../utils/documentFiles";


function DocumentViewer({
    currentDocument,
    printType,
    customPages,
    onLoadSuccess,
    printColor,
    orientation,
    printSide,
    copyCount,
    scaleMode,
    scalePercent,
}) {
    // Не-PDF (офисные форматы и изображения) идут через /convert/:id — см. documentFiles.js
    const needsConversion = !isPdf(currentDocument.file_name);
    const file = getDocumentFileUrl(currentDocument);

    return (
        <div
            className="flex-1 min-h-0 w-full flex flex-col"
        >
            {window.electronAPI?.pbreader ? (
                <PbReaderPreview currentDocument={currentDocument} printType={printType} customPages={customPages}
                    onLoadSuccess={onLoadSuccess} printColor={printColor} orientation={orientation} printSide={printSide} copyCount={copyCount} scaleMode={scaleMode} scalePercent={scalePercent} />
            ) : needsConversion ? (
                <DocView
                    file={file}
                    printType={printType}
                    customPages={customPages}
                    onLoadSuccess={onLoadSuccess}
                    printColor={printColor}
                    orientation={orientation}
                />
            ) : (
                <PDFViewer
                    file={file}
                    printType={printType}
                    customPages={customPages}
                    onLoadSuccess={onLoadSuccess}
                    printColor={printColor}
                    orientation={orientation}
                />
            )}
        </div>
    );
}

export default DocumentViewer;
